export const scrollTo = (id, position = 'top') => {
    let element = document.getElementById(id);
    let topPosition = position === 'bottom' ? element.offsetTop + element.offsetHeight - window.innerHeight : element.offsetTop;
    window.scrollTo({
        top: topPosition,
        behavior: 'smooth'
    });
}